import { render, staticRenderFns } from "./comments-item.vue?vue&type=template&id=195f2206&scoped=true"
import script from "./comments-item.vue?vue&type=script&lang=js"
export * from "./comments-item.vue?vue&type=script&lang=js"
import style0 from "./comments-item.vue?vue&type=style&index=0&id=195f2206&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f2206",
  null
  
)

export default component.exports